import TabBarSelect from './TabBarSelect';
import HeadTab from './HeadTab';

const Export = {
  TabBarSelect,
  HeadTab,
};

export default Export;
